/*
 * Copyright (c) 2016 Omnigon Communications, LLC. All rights reserved.
 *
 * This software is the confidential and proprietary information of Omnigon Communications, LLC
 * ("Confidential Information"). You shall not disclose such Confidential Information and shall access and use it only
 * in accordance with the terms of the license agreement you entered into with Omnigon Communications, LLC, its
 * subsidiaries, affiliates or authorized licensee. Unless required by applicable law or agreed to in writing, this
 * Confidential Information is provided on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either
 * express or implied. See the license agreement for the specific language governing permissions and limitations.
 */

import Component from 'can/component/component';
import template from './qualifying-local-table.stache';
import FeedService from 'scripts/services/base-feed-service';
import can from 'can';
import dayjs from 'dayjs';
import _ from 'lodash';
import settings from 'scripts/utils/settings';

const QualifyingLocalEventsFeedUrl =
    window.globalSettings.feeds.localQualifyingEvents;

const moduleSettings = settings.getModuleSettings('localQualifying');
const isLocalQualifyingEnabled = moduleSettings.isEnabled;
const disabledMessage = moduleSettings.unavailabilityMessage;

Component.extend({
    tag: 'qualifying-local-table',
    template: template,
    viewModel: {
        dataIsLoaded: false,
        sortType: 'asc',
        sortByKey: 'date',
        define: {
            isEnabled: {
                type: 'boolean',
                value: isLocalQualifyingEnabled,
            },
            disabledMessage: {
                type: 'string',
                value: disabledMessage,
            },
            infoModal: {
                type: 'string',
                value: '',
            },
            activeFilter: {
                Type: can.Map,
                Value: can.Map,
            },
            filters: {
                Type: can.List,
                Value: can.List,
            },
            events: {
                Type: can.List,
                Value: can.List,
            },
            filteredEvents: {
                get() {
                    can.batch.start();

                    let events = this.attr('events');
                    let date = this.attr('activeFilter').attr('date');
                    let formattedDate = dayjs(
                        date,
                        'YYYY-MM-DD HH:mm:ss',
                    ).format('MMM D, YYYY');
                    let sortType = this.attr('sortType');
                    let sortByKey = this.attr('sortByKey');

                    events.each(function(item, index, list) {
                        if (date == 'all dates') {
                            item.attr('visible', true);
                            return;
                        }

                        if (item.attr('formattedDate') != formattedDate) {
                            item.attr('visible', false);
                        } else {
                            item.attr('visible', true);
                        }
                    });

                    if (sortType && sortByKey) {
                        if (sortByKey == 'date') {
                            if (sortType == 'asc') {
                                events.attr('comparator', (a, b) => {
                                    return (
                                        Date.parse(a.attr('eventDate')) -
                                        Date.parse(b.attr('eventDate'))
                                    );
                                });
                            } else {
                                events.attr('comparator', (a, b) => {
                                    return (
                                        Date.parse(b.attr('eventDate')) -
                                        Date.parse(a.attr('eventDate'))
                                    );
                                });
                            }
                        } else {
                            events.attr('comparator', function(a, b) {
                                let aVal = a.attr(sortByKey) || null;
                                let bVal = b.attr(sortByKey) || null;
                                let sortDir = sortType == 'asc' ? -1 : 1;

                                if (aVal === null) return 1;
                                if (bVal === null) return -1;

                                return aVal === bVal
                                    ? 0
                                    : aVal < bVal
                                    ? sortDir
                                    : sortDir * -1;
                            });
                        }

                        events.sort();
                    }

                    can.batch.stop();
                    return events;
                },
            },
        },
        onFilterChange: function(event) {
            this.attr('activeFilter').attr('date', event.payload.value);
        },
    },
    events: {
        inserted() {
            this.viewModel.attr('activeFilter', { date: 'all dates' });
            this.qualifyingLocalTableFeedService = new FeedService(
                QualifyingLocalEventsFeedUrl,
                false,
                false,
            );
            this.qualifyingLocalTableFeedService.on('data', (ev, data) => {
                let validEvents = _.filter(data, (event) => {
                    if (dayjs(event.eventDate).isValid()) {
                        return true;
                    } else {
                        console.error('Invalid object', event);
                        return false;
                    }
                });

                this.viewModel.attr('events', validEvents);
                this.fillFilter();

                this.viewModel.attr('dataIsLoaded', true);
            });
            this.qualifyingLocalTableFeedService.fetch();
        },
        fillFilter: function() {
            let filters = [];

            this.viewModel.attr('events').each((element, index) => {
                let eventDate = element.attr('eventDate');
                let formattedDate = dayjs(
                    eventDate,
                    'YYYY-MM-DD HH:mm:ss',
                ).format('MMM D, YYYY');
                let formattedDateMobile = dayjs(
                    eventDate,
                    'YYYY-MM-DD HH:mm:ss',
                ).format('MMM D');
                element.attr('formattedDate', formattedDate);
                element.attr('formattedDateMobile', formattedDateMobile);
                element.attr('visible', true);
                let filter = { date: eventDate, formattedDate: formattedDate };
                let filterIndex = _.findIndex(filters, function(item) {
                    return (
                        item.date == filter.date &&
                        item.formattedDate == filter.formattedDate
                    );
                });
                if (filterIndex == -1) {
                    filters.push(filter);
                }
            });

            let sortedFilters = _.sortBy(filters, function(filter) {
                return Date.parse(filter.date);
            });
            sortedFilters.unshift({
                date: 'all dates',
                formattedDate: 'all dates',
            });
            this.viewModel.attr('filters', sortedFilters);
        },
        updateSortingOrder: function(element, key) {
            if (element.hasClass('is-sorting-asc')) {
                this.viewModel.attr('sortType', 'desc');
            } else if (element.hasClass('is-sorting-desc')) {
                this.viewModel.attr('sortType', 'asc');
            } else {
                this.viewModel.attr('sortType', 'asc');
            }

            this.viewModel.attr('sortByKey', key);
        },
        '.s-qualifying-local-table .s-table-body .s-table-row.drawer-available:not(.s-table-row--drawer) click': function(
            element,
            event,
        ) {
            if ($(event.target).closest('table.s-drawer-table').length) {
                return;
            }

            let expandedDrawer = this.element.find(
                '.s-qualifying-local-table .s-table-body tr.is-expanded',
            );
            let expandedDrawerBtns = this.element.find(
                '.s-qualifying-local-table .s-table-body tr.is-expanded .js-expand-drawer',
            );

            element.toggleClass('is-expanded');
            expandedDrawer.removeClass('is-expanded');

            const $dawerBtn = element.find('.js-expand-drawer');
            $dawerBtn.attr(
                'aria-expanded',
                $dawerBtn.attr('aria-expanded') == 'false' ? 'true' : 'false',
            );
            expandedDrawerBtns.attr('aria-expanded', false);
        },
        '.s-qualifying-local-table .s-table-head .s-table-cell--location click': function(
            element,
            event,
        ) {
            this.updateSortingOrder(element, 'location');
        },
        '.s-qualifying-local-table .s-table-head .s-table-cell--date click': function(
            element,
            event,
        ) {
            this.updateSortingOrder(element, 'date');
        },
        '.s-qualifying-local-table .s-table-head .s-table-cell--site click': function(
            element,
            event,
        ) {
            this.updateSortingOrder(element, 'site');
        },
    },
});
